export const getOrgId = (database, user) => (dispatch) => {
  const orgIdRef = database.ref(`users/${user.uid}/organization/orgId`)
  return orgIdRef.get()
      .then((snapshot) => {
        const orgId = snapshot.val()
        return orgId
      })
}
